// ('EVENT', { type: 'search', keyword: searchTerm });
export const track = (opts) => {
  if (typeof window !== 'undefined' && window.LIFE_CYCLE_EVENT_BUS) {
    window.LIFE_CYCLE_EVENT_BUS.trigger('sticky-nav.click', opts);
  }
};
